// Indian currency formatter: shows ₹ X Cr or ₹ X L based on size.
export function formatINR(crores) {
  const n = Number(crores) || 0;
  if (n === 0) return "₹ 0";
  if (Math.abs(n) >= 1) {
    // 1 Cr or more — show Cr
    const v = +n.toFixed(2);
    return `₹ ${v.toLocaleString("en-IN", { maximumFractionDigits: 2 })} Cr`;
  }
  // less than 1 Cr — show in Lakhs (1 Cr = 100 L)
  const lakhs = +(n * 100).toFixed(2);
  return `₹ ${lakhs.toLocaleString("en-IN", { maximumFractionDigits: 2 })} L`;
}

export function formatLakhs(lakhs) {
  const n = Number(lakhs) || 0;
  if (Math.abs(n) >= 100) {
    return `₹ ${(n / 100).toLocaleString("en-IN", { maximumFractionDigits: 2 })} Cr`;
  }
  return `₹ ${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })} L`;
}

export function formatNumber(n) {
  return Number(n || 0).toLocaleString("en-IN");
}

export function formatPercent(num, denom, digits = 1) {
  if (!denom) return "0%";
  return `${((num / denom) * 100).toFixed(digits)}%`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
}

export function formatDateShort(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}
